module.exports = __webpack_public_path__ + "static/social-image-b975c37a35387662bf73ef4093ae589b.png";